import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';

export const SwaggerDocs = () => {
  const version = import.meta.env.VITE_BUILD_VERSION;
  return (
    <SwaggerUI
      url={`/assets/api/swagger.yaml?v=${version}`}
      docExpansion="none"
      deepLinking
      showExtensions={false}
      // presets={[SwaggerUIBundle.presets.apis, SwaggerUIStandalonePreset]}
    />
  );
};
